.column {
  container: variant / inline-size;
  display: flex;
  flex-direction: column;
  min-height: 0;
  min-width: 0;
  background: var(--surface-2);
  /* Обводка — цветом самого варианта, а не нейтральным бордером: колонки стоят
     рядом и различаться должны с одного взгляда, а точки в шапке для этого мало.
     Минимум 2px даже в темах с волоском: цветная линия в один пиксель на фоне
     соседней колонки читается как случайный шов. */
  border: max(2px, var(--bw)) solid var(--variant-color, var(--border-strong));
  box-shadow: var(--glass-rim);
  border-radius: var(--radius-lg);
  /* Радиус изнутри обводки — по нему скругляются дети, которые упираются в
     углы колонки (сводка внизу). Считается здесь, а не у них: толщина обводки
     живёт тут же, и вычитать её на месте пришлось бы каждому. */
  --inner-radius: calc(var(--radius-lg) - max(2px, var(--bw)));
  transition: border-color var(--dnd-dur) var(--dnd-ease), box-shadow var(--dnd-dur) var(--dnd-ease);
}

.column.dropTarget {
  border-color: var(--focus);
  box-shadow: var(--glass-rim), 0 0 0 1px var(--focus) inset;
}

/* Заблокированный вариант: пунктир по контуру — состояние видно, даже когда
   шапка с замком ушла за пределы экрана. Цвет остаётся свой: замок меняет
   режим варианта, а не то, какой это вариант. */
.column.locked {
  border-style: dashed;
}

/* Все контролы и чипы шапки одной высоты: строка должна читаться как одна
   линия, без выступающих элементов. Переменная уезжает и в чипы сводки. */
.header {
  --hdr-ctl-h: 28px;
  position: relative;
  display: flex;
  align-items: center;
  /* Строго одна строка: высота шапки не должна зависеть ни от длины названия,
     ни от того, сколько чипов насчитала сводка. */
  flex-wrap: nowrap;
  gap: var(--sp-3);
  flex: none;
  padding: var(--sp-4) var(--sp-5);
  border-bottom: 1px solid var(--border);
  /* Пустое место шапки сворачивает вариант — курсор об этом и сообщает.
     Контролы внутри перебивают его своим (имя — текстовым). */
  cursor: pointer;
}

/* Прибито слева и сдаётся последним: аккордеон и название — то, по чему
   вариант вообще опознают. */
.headerLead {
  display: flex;
  align-items: center;
  gap: var(--sp-3);
  flex: 0 1 auto;
  min-width: 0;
}

/* Середина забирает остаток ширины и увозит сводку в свою прокрутку —
   так действия справа всегда остаются на месте. */
.headerScroll {
  flex: 1 1 0;
  min-width: 0;
  overflow-x: auto;
  overflow-y: hidden;
  /* Полоса прокрутки съела бы половину высоты строки, а горизонтальный сдвиг
     и так виден по обрезанному чипу. */
  scrollbar-width: none;
}

.headerScroll::-webkit-scrollbar {
  display: none;
}

/* Прибито справа и не ужимается никогда. */
.headerActions {
  display: flex;
  align-items: center;
  gap: var(--sp-3);
  flex: none;
}

/* Варианты идут во всю ширину канваса: таймлайн и итоги встают рядом, иначе справа
   остаётся большое пустое поле. Порог — по ширине самого варианта, а не окна:
   канвас сужается и расширяется при сворачивании боковых панелей. */
/* stretch, а не start: сбоку от таймлайна сводка должна доходить до низа
   варианта, иначе её линия отрыва обрывается на середине колонки. */
.body {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  align-items: stretch;
  min-height: 0;
}

@container variant (min-width: 720px) {
  .body {
    grid-template-columns: minmax(0, 1fr) 280px;
  }
}

.collapseBtn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: none;
  width: var(--hdr-ctl-h);
  height: var(--hdr-ctl-h);
  padding: 0;
  background: transparent;
  border: var(--bw) solid transparent;
  border-radius: var(--radius);
  color: var(--text-2);
  cursor: pointer;
}

.collapseBtn:hover {
  background: var(--surface);
  color: var(--text);
}

/* Стрелки порядка — один столбик в ширину иконки: две половинки одна над другой. */
.moveGroup {
  display: flex;
  flex-direction: column;
  flex: none;
}

.moveBtn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: calc(var(--hdr-ctl-h) / 2);
  padding: 0;
  font-size: 10px;
  line-height: 1;
  color: var(--text-2);
  border-radius: 0;
}

.moveBtn:first-child {
  border-radius: var(--radius) var(--radius) 0 0;
  /* Общая граница между половинками: иначе посередине двойная линия. */
  border-bottom: none;
}

.moveBtn:last-child {
  border-radius: 0 0 var(--radius) var(--radius);
}

/* Проверка цен всего варианта. Кнопка с подписью, а не иконка: она уходит в
   сеть и трогает сразу несколько рейсов — такое стоит называть словами.
   Класс уезжает на саму кнопку (модуль цен оборачивает её своим span), поэтому
   здесь только её собственная геометрия: высота — общая для строки шапки, а
   переносить подпись с числом рейсов нельзя, шапка строго однострочная. */
.priceBtn {
  white-space: nowrap;
}

/* Высоту навязываем только там, где кнопка с подписью: на телефоне она
   компактная, и размер ей задаёт свой же модуль (24×24 / 38×32). Спорить с ним
   одинаковой специфичностью бессмысленно — победителя решил бы порядок сборки. */
@media (min-width: 721px) {
  .priceBtn {
    height: var(--hdr-ctl-h);
  }
}

/* Квадратные кнопки-иконки шапки: клон и замок. */
.iconBtn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: none;
  width: var(--hdr-ctl-h);
  height: var(--hdr-ctl-h);
  padding: 0;
  line-height: 1;
  color: var(--text-2);
}

.lockBtnOn {
  color: var(--text);
  border-color: var(--border-strong);
  background: var(--surface-2);
}

/* Маркер цвета занимает ту же высоту, что и остальные элементы шапки, но
   рисует кружок по центру — иначе он выбивался бы из общей линии. */
.dot {
  display: inline-flex;
  align-items: center;
  flex: none;
  width: 10px;
  height: var(--hdr-ctl-h);
}

.dot::before {
  content: '';
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: var(--variant-color);
}

.nameBtn {
  flex: 0 1 auto;
  min-width: 0;
  max-width: 28ch;
  height: var(--hdr-ctl-h);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
  padding: 0 var(--sp-2);
  margin-inline: calc(var(--sp-2) * -1);
  background: transparent;
  border: var(--bw) solid transparent;
  border-radius: var(--radius);
  font-size: var(--fs-lg);
  font-weight: 600;
  line-height: var(--hdr-ctl-h);
  cursor: text;
}

.nameBtn:hover:not(:disabled) {
  background: var(--surface);
}

.nameBtn:disabled {
  cursor: default;
}

.nameInput {
  flex: 0 1 auto;
  min-width: 0;
  height: var(--hdr-ctl-h);
  font-size: var(--fs-lg);
  font-weight: 600;
  padding: 0 var(--sp-2);
}

.headerMenuWrap {
  position: relative;
  flex: none;
}

.menuBtn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: var(--hdr-ctl-h);
  height: var(--hdr-ctl-h);
  padding: 0;
  line-height: 1;
}

.menu {
  position: absolute;
  top: calc(100% + var(--sp-2));
  right: 0;
  z-index: 10;
  display: flex;
  flex-direction: column;
  gap: var(--sp-3);
  min-width: 180px;
  padding: var(--sp-4);
  background: var(--surface);
  border: var(--bw) solid var(--border-strong);
  border-radius: var(--radius-lg);
  -webkit-backdrop-filter: var(--glass-blur);
  backdrop-filter: var(--glass-blur);
  box-shadow: var(--glass-rim), var(--shadow-modal);
}

.menuLabel {
  font-size: var(--fs-sm);
  color: var(--text-2);
}

/* 24 цвета в строку не помещаются — сетка 6×4. Ширина ряда выбрана под палитру:
   первый ряд занимают ровно шесть приглушённых, ниже идут яркие. */
.palette {
  display: grid;
  grid-template-columns: repeat(6, 20px);
  gap: var(--sp-2);
}

.swatch {
  width: 20px;
  height: 20px;
  padding: 0;
  border-radius: 50%;
  border: 2px solid transparent;
  cursor: pointer;
}

.swatch:hover {
  border-color: var(--border-strong);
}

.swatchActive {
  border-color: var(--text);
}

.deleteBtn {
  justify-content: center;
}

@media (prefers-reduced-motion: reduce) {
  .column {
    transition: none;
  }
}
